<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
    <input (ngModelChange)="updateNgModel($event);" [(ngModel)]="childValue" [disabled]="disabled" [formControl]="childControl" matInput
           [matAutocomplete]="autoAccounts" [required]="required">
    <button type="button" matIconSuffix mat-icon-button (click)="childValue = null; value = null;">
        <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #autoAccounts="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let res of listResults" [value]="res">{{res.Code}} - {{res.Name}}</mat-option>
    </mat-autocomplete>
    <mat-icon *ngIf="childValue?.IsBlocked" matIconSuffix matTooltip="This relation is blocked">warning</mat-icon>
    <mat-hint *ngIf="childValue?.Code">{{childValue.Code}}</mat-hint>
</mat-form-field>
